import {updateProfilerViewer} from '@wandb/common/util/profiler';
import React, {FC, memo, useEffect} from 'react';

import {GALLERY_PATH_SEGMENT} from '../../../routes/paths';
import {isInIframe} from '../../../setup';
import {useViewer} from '../../../state/viewer/hooks';
import {useIsAdminModeActiveAndIsNotLocalEnv} from '../../../util/admin';
import {useNavContext} from '../../NavContextProvider';
import NavLeft from './NavLeft';
import NavRight from './NavRight';
import * as S from './SearchNav.styles';

const SearchNav: FC = memo(() => {
  const {hidden} = useNavContext();

  useUpdateProfilerViewer();

  // hide the search nav in gallery for mobile
  const currentPath: string = window.location.pathname.split('/')[1] ?? '';
  const isMobileGallery = currentPath === GALLERY_PATH_SEGMENT;
  const isSignup = currentPath === 'signup';
  const showAdminBanner = useIsAdminModeActiveAndIsNotLocalEnv();

  if (hidden) {
    return null;
  }
  // TODO: this component is getting re-rendered on each poll...
  return (
    <S.SearchNav
      showAdminBanner={showAdminBanner}
      className={`search-nav ${
        isMobileGallery ? 'hide-in-mobile-gallery' : ''
      }`}
      id="searchNav">
      {!isInIframe() && (
        <S.ExperimentalTestBar
          id="search-nav-experimental-test-bar"
          showAdminBanner={showAdminBanner}
        />
      )}
      <NavLeft />
      <NavRight isSignup={isSignup} />
    </S.SearchNav>
  );
});

export default SearchNav;

function useUpdateProfilerViewer(): void {
  const viewer = useViewer();
  const {
    params: {entityName, projectName},
  } = useNavContext();

  useEffect(() => {
    updateProfilerViewer(entityName, projectName, viewer?.admin);
  }, [entityName, projectName, viewer?.admin]);
}
